import React from "react";
import { Nav } from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";
import moment from "moment";

import AuthContext from "../../../context/AuthContext";

import CardAxa from "../../../components/statistics/statistics-axa/CardAXA";
import ShowOptionsAxa from "../../../components/statistics/statistics-axa/ShowOptionsAxa";

export default class StatisticsAxa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateStart: moment().format("YYYY-01-01"),
      dateEnd: moment().format("YYYY-MM-DD"),
      departments: null,
      VTHG: "0",
    };
  }

  static contextType = AuthContext;

  handleFilterChange = (filters) => {
    this.setState({
      dateStart: filters.dateStart,
      dateEnd: filters.dateEnd,
      departments: filters.departments,
      VTHG: filters.VTHG,
    });
  };

  render() {
    return (
      <>
        <FadeIn>
          <Nav title="Statistiques spécifiques" className="mb-20" />
          <ShowOptionsAxa
            className="mb-20"
            dateStart={this.state.dateStart}
            dateEnd={this.state.dateEnd}
            onFilterChange={this.handleFilterChange}
          />
          <CardAxa
            departments={this.state.departments}
            dateStart={this.state.dateStart}
            dateEnd={this.state.dateEnd}
            VTHG={this.state.VTHG}
          />
        </FadeIn>
      </>
    );
  }
}
